import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  useListContext,
  TopToolbar,
  CreateButton,
  ExportButton,
  sanitizeListRestProps,
  Filter,
  TextInput,
} from "react-admin";

export const QuestionFilter = (props) => (
  <Filter {...props}>
    <TextInput source="exam_name" alwaysOn label="Exam Name" />
    <TextInput source="question" label="Question" />
  </Filter>
);

const QuestionActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
    total,
  } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filterValues={filterValues}
        maxResults={maxResults}
      />
    </TopToolbar>
  );
};

export const QuestionList = (props) => (
  <List
    {...props}
    filters={<QuestionFilter />}
    perPage={20}
    sort={{ field: "exam_name", order: "ASC" }}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField source="training_name" label="Training" />
      <TextField source="exam_name" label="Exam Name" />
      <TextField source="passing_percentage" label="Passing Percentage" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
);

export default QuestionList;
